import ReactMarkdown from "react-markdown";
import { useLang } from "@/context/LangContext";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex rounded-full border border-slate-200 bg-white p-0.5 text-xs font-bold ${className}`} data-testid="lang-toggle">
      {["fr", "en"].map((l) => (
        <button key={l} type="button" data-testid={`lang-option-${l}`} onClick={() => setLang(l)}
          className={`rounded-full px-2.5 py-1 uppercase transition-colors ${lang === l ? "bg-indigo-600 text-white" : "text-slate-500 hover:text-slate-900"}`}>{l}</button>
      ))}
    </div>
  );
};

export const AiText = ({ text, testId }) => (
  <div className="prose-ai text-sm leading-relaxed text-slate-700" data-testid={testId}>
    <ReactMarkdown>{text}</ReactMarkdown>
  </div>
);

export const ModelPicker = ({ value, onChange }) => (
  <div className="inline-flex rounded-full border border-slate-200 bg-white p-1 text-xs font-semibold" data-testid="model-picker">
    {[["claude", "Claude Sonnet 5.5"], ["gpt", "GPT 6 Luna"]].map(([id, label]) => (
      <button key={id} type="button" data-testid={`model-option-${id}`} onClick={() => onChange(id)}
        className={`rounded-full px-3 py-1.5 transition-colors ${value === id ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-900"}`}>
        {label}
      </button>
    ))}
  </div>
);

export const PageHeader = ({ eyebrow, title, subtitle, children }) => (
  <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-indigo-600">{eyebrow}</div>
      <h1 className="mt-2 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="mt-3 max-w-2xl text-sm sm:text-base text-slate-500">{subtitle}</p>}
    </div>
    {children}
  </div>
);
